<script setup>
import '@eonasdan/tempus-dominus/dist/css/tempus-dominus.css';
import { TempusDominus, Namespace, loadLocale, locale } from '@eonasdan/tempus-dominus';
import { localization, name } from '../../vendor/tempus-dominus/locales/hu';
import { DateTime } from 'luxon';
</script>

<script>
export default {
    props: {
        id: {
            type: String,
            required: true
        },
        class: {
            type: String
        },
        placeholder: {
            type: String,
        },
        required: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        pickerType: {
            type: String,
            default: 'calendar'
        },
        pickerFormat: {
            type: String,
            required: true
        },
        minDate: {
            type: Date,
        },
        maxDate: {
            type: Date
        },
        modelValue: {
            type: String
        },
    },
    data() {
        return {
            picker: null
        }
    },
    emits: [
        'update:modelValue'
    ],
    methods: {

        initPicker() {

            const that = this;

            // Load locale
            if (document.documentElement.lang == 'hu') {

                loadLocale({
                    localization,
                    name
                });

                locale(name);

            }

            // Set icons
            const displayOptions = {
                icons: {
                    type: 'icons',
                    time: 'fas fa-clock',
                    date: 'fas fa-calendar',
                    up: 'fas fa-arrow-up',
                    down: 'fas fa-arrow-down',
                    previous: 'fas fa-chevron-left',
                    next: 'fas fa-chevron-right',
                    today: 'fas fa-calendar-check',
                    clear: 'fas fa-trash',
                    close: 'fas fa-xmark'
                }
            };

            // Set restrictions
            let restricitons = {};
            if (this.minDate) {
                restricitons.minDate = that.minDate;
            }
            if (this.maxDate) {
                restricitons.maxDate = that.maxDate;
            }

            // Init picker
            this.picker = new TempusDominus(that.$refs.pickerElement, {
                display: {
                    ...displayOptions,
                    viewMode: that.pickerType == 'calendar' || that.pickerType == 'dateTimePicker' ? 'calendar' : 'clock',
                    components: {
                        calendar: (that.pickerType == 'calendar' || that.pickerType == 'dateTimePicker'),
                        clock: (that.pickerType == 'clock' || that.pickerType == 'dateTimePicker'),
                    },
                },
                defaultDate: that.modelValue ? DateTime.fromISO(that.modelValue).toJSDate() : undefined,
                localization: {
                    format: that.pickerFormat,
                },
                restrictions: restricitons,
            });

            // Subscribe to change event
            this.picker.subscribe(Namespace.events.change, (e) => {
                if (e.isValid) {
                    // that.$emit('update:displayValue', this.$refs.pickerElement.value);

                    const selectedDate = DateTime.fromJSDate(e.date);
                    switch (that.pickerType) {
                        case 'dateTimePicker':
                            that.$emit('update:modelValue', selectedDate.toISO());
                            break;
                        case 'calendar':
                            that.$emit('update:modelValue', selectedDate.toISODate());
                            break;
                        case 'clock':
                            // that.$emit('update:modelValue', selectedDate.toLocaleString(DateTime.TIME_24_SIMPLE));
                            that.$emit('update:modelValue', selectedDate.toFormat('HH:mm'));
                            break;
                        default:
                            that.$emit('update:modelValue', '???');
                            break;
                    }
                }
            });
        },

        setDate() {
            console.log('Set date!');
        }

    },
    mounted() {
        this.initPicker();
    }
}
</script>

<template>
    <input type="text" :id="id" :class="class" :placeholder="placeholder" :disabled="disabled" autocomplete="off" readonly ref="pickerElement" />
    <label :for="id">{{ placeholder }} <span class="text-danger" v-if="required">*</span></label>
</template>
